import { Component, effect } from "@angular/core";
import { CurrencyPipe } from "@angular/common";
import { DirectSessionLogicService } from "../shared/direct-session-logic.service";
import { ConfigData } from "../shared/models/config-data.model";

import { environment } from "../../environments/environment";
import { ItemFormat } from "../shared/models/itemFormat.model";
import { CustomerFormat } from "../shared/models/customerFormat.model";
import { Plan } from "../shared/models/plan.model";
import { PromoService } from "../shared/promo.service";

@Component({
    selector: 'app-confirmation-page',
    templateUrl: './confirmation-page.component.html',
    styleUrls: ['./confirmation-page.component.scss'],
    standalone: true,
    imports: [ CurrencyPipe ],
})

export class ContractCompletionPage{

    selections: ItemFormat[] = [];
    customer: CustomerFormat = {} as CustomerFormat;

    get plan() { return this.directSessionLogic.planSelectedSignal(); }
    get cartItems() { return this.directSessionLogic.cartItemsSignal(); }
    get discount() { return this.directSessionLogic.returnDiscount() ?? 0; }
    get subtotal() { return parseFloat((this.paymentAmount + this.discount).toFixed(2)); }
    get couponCode() { return this.promoService.couponSignal()?.code ?? ''; }

    childrenResponse: string = '';
    emailProxy: string = '';
    companyName: string = '';
    customerServicePhoneNumber: string = '';
    customerServicePhoneDisplay: string = '';

    customerName: string = '';
    planName: string = '';
    paymentAmount: number = 0;
    paymentMethod: string = '';

    memeberID: string = '';
    purchaseRef: string = '';

    paymentDate: string = '';

    constructor(
        public directSessionLogic: DirectSessionLogicService,
        public promoService: PromoService,
    ){
        // Non-prod builds with localDebug on get a fully stubbed session so the
        // receipt page can be opened directly. environment.production is a build-time
        // constant, so this whole block is dead code (tree-shaken) in the prod build.
        if(!environment.production && environment.ConnectionInfo.localDebug === "true") {
            this.loadDebugData();
        }

        this.initResults();
        this.initConfig();

        this.paymentDate = new Date().toLocaleDateString('en-US');

        if(this.directSessionLogic.selectedPlanSignalValue === undefined) {
            this.directSessionLogic.escapeToTopLevelSignal()
        }

        effect(() => {
            this.customer = this.directSessionLogic.customerSignal();
            this.customerName = this.customer.firstName + ' ' + this.customer.lastName;
            this.paymentMethod = this.customer.cardType + ' – **** **** **** ' + this.customer.ccLast4;
        });

        effect(() => {
            this.planName = this.directSessionLogic.planSelectedSignal().name ?? "";
        });

        effect(() => {
            this.purchaseRef = this.directSessionLogic.trimmedSessionSignal().purchaseRef;
            this.paymentAmount = this.directSessionLogic.trimmedSessionSignal().totalCost ?? 0;
        });

        this.memeberID = 'Didn\'t get policy from forte yet.';
    }

    async initResults() {
        this.childPlanSpecificCheck();
        this.emailProxyBuilder();
    }

    async initConfig() {
        this.companyName = environment.CompanyInfo.CompanyName;
        this.customerServicePhoneDisplay = environment.CompanyInfo.CustomerServicePhoneDisplay;
        this.customerServicePhoneNumber = "+" + this.customerServicePhoneDisplay.replace(/\D/g,"");
    }

    childPlanSpecificCheck() {
        const cartItems = this.directSessionLogic.cartItemsSignal();
        if(cartItems && cartItems.length > 0) {
            this.childrenResponse = "Added";
        } else {
            this.childrenResponse = "Not Added";
        }
    }

    emailProxyBuilder(){
        let customer = this.directSessionLogic.customerSignal();
        if(!customer.email || !customer.email.includes('@')) return;
        let emailPrefix = customer.email.split('@')[0];
        let emailSuffix = customer.email.split('@')[1];
        this.emailProxy = emailPrefix.slice(0, 2) + '****' + emailPrefix.slice(-2) + "@" + emailSuffix;
    }

    loadDebugData() {
        const stubPlan = {
            name: 'ShieldSafe Individual',
            price: 19.99,
            forteCode: 'SSINDPREM',
            defaultIncluded: [],
            features: [],
            salesPoints: [],
        } as unknown as Plan;

        const stubCustomer: CustomerFormat = {
            firstName: 'John',
            lastName: 'Sandbox',
            email: 'johnsandbox@testdomain.com',
            phoneNumber: '5555555555',
            address: '1234 Main St',
            city: 'Anytown',
            state: 'CA',
            zip: '12345',
            zipLast4: '2345',
            country: 'United States',
            cardType: 'Visa',
            ccLast4: '1111',
            ccExpMonth: '12',
            ccExpYear: '26',
            cardHolderName: 'John Sandbox',
            cardEncrypted: '',
            dateEncrypted: '',
            deliveryPointCode: '',
            deliveryPointCheckDigit: '',
        };

        this.directSessionLogic.setPlanSelectedSignal(stubPlan);
        this.directSessionLogic.updateCustomerSignal(stubCustomer);
        this.directSessionLogic.updateTrimmedSessionSignal({
            ...this.directSessionLogic.trimmedSessionSignal(),
            purchaseRef: 'DEBUG-REF-123456',
            totalCost: 19.99,
            customerId: 'DBG-001',
        });
    }
}
